module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Things Love Can’t Teach You")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#chapter-1-love-life"
    }
  }, [_vm._v("Chapter 1: Love Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#chapter-2-work-life"
    }
  }, [_vm._v("Chapter 2: Work Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-3-love-quarrel"
    }
  }, [_vm._v("Chapter 3: Love Quarrel")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#chapter-4-drunken-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Drunken Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-5-heartbreak",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Heartbreak")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-6-private-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Private Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-7-love-angels",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Love Angels")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-8-love-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Love Back")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-9-aftermath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Aftermath")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-10-friendship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Friendship")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-11-office-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Office Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-12-sexy-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Sexy Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-13-fresh-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Fresh Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-14-miami-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Miami Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-15-sibling-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Sibling Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-16-mischief-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Mischief Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-17-love-horror",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Love Horror")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-18-steaming-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Steaming Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-19-love-confession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Love Confession")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-20-love-lost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Love Lost")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0